import { render, staticRenderFns } from "./DPlayerSettingSpeed.vue?vue&type=template&id=d2a69544&scoped=true&"
import script from "./DPlayerSettingSpeed.vue?vue&type=script&lang=js&"
export * from "./DPlayerSettingSpeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a69544",
  null
  
)

export default component.exports